import Component from "../../../classes/Component";
import {animationTargetAttr, initSectionsAnimations} from "../components/animation/helpers";

export default function () {
    return new Component({
        name: 'landingRedragonAnimation',
        requiredTargets: `[${animationTargetAttr}^='redragon-']`,
        onInit() {
            initSectionsAnimations([
                {
                    name: 'description',
                    axis: 'x'
                },
                {
                    name: 'redragon-models',
                    axis: 'x'
                },
                {
                    name: 'redragon-benefits',
                    axis: 'x'
                },
                {
                    name: 'redragon-benefits-percents',
                    axis: 'x'
                },
                {
                    name: 'redragon-promotion',
                    axis: 'x'
                },
                {
                    name: 'feedback',
                    axis: 'x',
                    oddAxis: true
                },
                {
                    name: 'footer',
                    axis: 'x',
                    oddAxis: true
                }
            ], '10% 95%')
        }
    })
}
